import script from "./moneyList.vue?vue&type=script&setup=true&lang=js"
export * from "./moneyList.vue?vue&type=script&setup=true&lang=js"

import "./moneyList.vue?vue&type=style&index=0&id=6083ac28&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6083ac28"]])

export default __exports__